import { useEffect, useState } from 'react';
import { Reservation } from '../services/coworkerApiCalls/Reservations/ReservationsTypes';
import { getReservations } from '../services/coworkerApiCalls/Reservations/Reservations';
import { reservationResponsesToReservations } from '../services/helpers/ReservationMapper';
import { ID_SPACE } from '../constant';
import { useOktaAuth } from '@okta/okta-react';

function useDataApi(startDate: number, endDate: number, refreshKey:number/*, open: number*/): Reservation[] {
    const [reservations, setReservations] = useState<Reservation[]>([]);

    const { authState } = useOktaAuth();
    const token = authState!.idToken!.idToken
    
    useEffect(() => {
        const getUsers = async () => {
            const reservationsTemporary = await getReservations(token, ID_SPACE, startDate, endDate);
            /*if (reservationsTemporary.length === 0) {
                toast.info('No Reservations', {
                    position: "top-right",
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
        }*/
            const reservationResult = reservationResponsesToReservations(reservationsTemporary);
            setReservations(reservationResult);
        };
        void getUsers();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refreshKey/*open,*/]); // Or [] if effect doesn't need props or state
    return reservations;
}


export { useDataApi }